import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { House, ListChecks, Users, MapTrifold, UserCircle, SignOut, ChartBar, Buildings, MapPinLine, Upload, CheckCircle, EnvelopeSimple, Translate, Key, Storefront, PenNib, User } from "@phosphor-icons/react";

const items = [
  { to: "/admin", label: "Dashboard", icon: House, end: true },
  { to: "/admin/analytics", label: "Analytics", icon: ChartBar, adminOnly: true },
  { to: "/admin/listings", label: "Listings (Sales)", icon: ListChecks },
  { to: "/admin/rentals", label: "Rentals (Internal)", icon: Key },
  { to: "/admin/projects", label: "Projects (Off-plan)", icon: Buildings },
  { to: "/admin/communities", label: "Communities", icon: MapPinLine, adminOnly: true },
  { to: "/admin/developers", label: "Developers", icon: Storefront, adminOnly: true },
  { to: "/admin/journal", label: "Journal (AI daily)", icon: PenNib, adminOnly: true },
  { to: "/admin/imports", label: "Data imports", icon: Upload, adminOnly: true },
  { to: "/admin/approvals", label: "Approvals", icon: CheckCircle, adminOnly: true },
  { to: "/admin/translations", label: "Translations", icon: Translate, adminOnly: true },
  { to: "/admin/leads", label: "Leads (CRM)", icon: Users },
  { to: "/admin/email-templates", label: "Email templates", icon: EnvelopeSimple, adminOnly: true },
  { to: "/admin/areas", label: "Area guides", icon: MapTrifold, adminOnly: true },
  { to: "/admin/agents", label: "Agents", icon: UserCircle, adminOnly: true },
  { to: "/admin/profile", label: "My profile", icon: User },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (!user) return null;
  return (
    <div className="pp-light min-h-screen" data-testid="admin-layout">
      <div className="flex">
        {/* Sidebar */}
        <aside className="w-64 min-h-screen border-r border-[#E5E7EB] bg-white sticky top-0 flex flex-col">
          <Link to="/admin" className="flex items-center justify-center px-6 py-6 border-b border-[#E5E7EB]" data-testid="admin-logo-link">
            <img
              src="https://customer-assets.emergentagent.com/job_penta-realty-uae/artifacts/lk46xfkn_Point%20Penta%20Logo%20png.png"
              alt="Point Penta"
              className="h-14 w-auto"
            />
          </Link>
          <nav className="p-3 flex-1">
            {items
              .filter((i) => !i.adminOnly || user.role === "admin")
              .map((i) => (
                <NavLink
                  key={i.to} to={i.to} end={i.end}
                  data-testid={`admin-nav-${i.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                      isActive ? "bg-[#001588] text-white" : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  <i.icon size={18} weight="thin" /> {i.label}
                </NavLink>
              ))}
          </nav>
          <div className="p-4 border-t border-[#E5E7EB]">
            <div className="text-sm font-medium">{user.name}</div>
            <div className="text-xs text-gray-500 capitalize mb-3">{user.role === "founding_partner" ? "Founding Partner" : user.role}</div>
            <button
              onClick={() => { logout(); window.location.href = "/"; }}
              className="flex items-center gap-2 text-sm text-gray-600 hover:text-red-600"
              data-testid="admin-logout"
            >
              <SignOut size={14} /> Sign out
            </button>
          </div>
        </aside>

        <main className="flex-1 min-h-screen">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
